<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <h2>Resguardo de Datos</h2>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Inicio</a></li>
                        <li>Servicios</li>
                        <li>Resguardo de Datos</li>
                    </ul>
                </div>
            </div>

            <div class="special-intro-offer-wrap">
                <div class="row">
                    <h4 style="color: #FFF;">Características</h4>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-shield"></i>
                            <h3>Seguridad de nivel empresaria</h3>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-rocket"></i>
                            <h3>Alta disponibilidad y redundancia</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-headset"></i>
                            <h3>Soporte técnico especializado 24/7</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-window-restore"></i>
                            <h3>Recuperación ante desastres y versiones históricas</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-gears"></i>
                            <h3>Escalabilidad y personalización</h3>

                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <div class="reseller-item">
                            <i class="fa-solid fa-eye"></i>
                            <h3>Cumplimiento normativo y auditorías</h3>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>







<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="customer-title">
                    <h2 class="text-center"> Resguardo de Datos Seguro y Confiable</h2>
                    <p class="text-justify">
                        En un mundo donde los datos son el activo más valioso, su control y propiedad pueden ser objeto
                        de disputas entre empresas, instituciones y usuarios. Mientras estas discusiones ocurren, es
                        crucial que la información esté resguardada en un entorno seguro y accesible solo para las
                        partes autorizadas.



                    </p>
                    <p class="text-justify"> enCloud actúa como un intermediario de confianza, almacenando los datos en
                        un sistema seguro, inmutable y con auditoría completa. No tomamos partido, solo garantizamos la
                        integridad y disponibilidad de la información mientras se resuelven disputas o procesos
                        administrativos.</p>


                </div>
            </div>
        </div>
    </div>
</section>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">


                <div class="customer-title">
                    <h2 class="text-center">¿Cómo Funciona el Resguardo de Datos?</h2>
                    <p>Mientras las entidades definen quién tiene el control final de los datos, nosotros aseguramos su
                        protección y acceso bajo estrictos protocolos de seguridad.</p>
                    <ul class="custom-list">
                        <li><strong>Almacenamiento Seguro</strong> – Los datos son cifrados y almacenados en servidores
                            redundantes.</li>
                        <li><strong>Accesos Controlados</strong> – Solo usuarios autorizados pueden acceder a la
                            información, según permisos definidos.</li>
                        <li><strong>Trazabilidad Total</strong> – Cada acción queda registrada, evitando manipulaciones
                            indebidas.</li>
                        <li><strong>Disponibilidad Garantizada</strong> – Mantenemos la información accesible mientras
                            se resuelve cualquier disputa legal, contractual o administrativa.</li>
                        <li><strong>Imparcialidad y Confianza</strong> – No intervenimos en el conflicto, solo
                            aseguramos que los datos estén protegidos.</li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>



<section class="customer-support-area pt-70">

    <div class="container">
        <h1 class="text-center">Casos Donde el Control de Datos Está en Disputa</h1>

        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="frequently-content-wrap">
                    <ul>
                        <li>
                            <i class="fa-solid fa-building"></i>
                            <h3>Disputas contractuales entre empresas</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Dos partes reclaman la propiedad de un acuerdo o
                                    documentación financiera.</a>
                                <a>🛡️ <strong>Solución:</strong> Almacenamiento seguro e inalterable hasta que se
                                    resuelva el conflicto.</a>
                            </div>
                        </li>
                        <li>

                            <i class="fa-solid fa-handshake"></i>
                            <h3>Conflictos por propiedad intelectual</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Empresas disputan la titularidad de código fuente,
                                    diseños o patentes.</a>
                                <a>🛡️ <strong>Solución:</strong> Auditoría y almacenamiento inmutable que preserva
                                    evidencia.</a>
                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-people-carry-box"></i>
                            <h3>Separaciones empresariales o escisiones</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Empresas dividen operaciones y necesitan acceso
                                    temporal a datos compartidos.</a>
                                <a>🛡️ <strong>Solución:</strong> Resguardo con permisos diferenciados hasta que se
                                    asigne la propiedad.</a>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-notes-medical"></i>
                            <h3>Acceso a registros médicos entre hospitales y aseguradoras</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Diferentes entidades necesitan consultar información,
                                    pero no pueden compartir bases de datos. </a>
                                <a>🛡️ <strong>Solución:</strong> Plataforma segura de acceso segmentado según permisos
                                    .</a>
                            </div>
                        </li>

                        <li>
                            <i class="fa-solid fa-gavel"></i>
                            <h3>Retención de datos en procesos legales</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Un litigio requiere proteger y conservar datos sin
                                    alteraciones.</a>
                                <a>🛡️ <strong>Solución:</strong> Protección inmutable con hashing criptográfico y
                                    registros de acceso.</a>
                            </div>
                        </li>
                        <li>
                            <i class="fa-solid fa-users"></i>
                            <h3>Disputas por acceso en empresas familiares o sociedades</h3>
                            <div class="row">
                                <a>⚖️ <strong>Conflicto:</strong> Diferentes socios reclaman el control de información
                                    estratégica.</a>
                                <a>🛡️ <strong>Solución:</strong> Neutralidad en la custodia de datos, accesibles solo
                                    bajo acuerdo legal.</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
</section>


<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">


                <div class="customer-title">
                    <h2 class="text-center">Beneficios del Resguardo de Datos</h2>
                    <p>Mientras las entidades definen quién tiene el control final de los datos, nosotros aseguramos su
                        protección y acceso bajo estrictos protocolos de seguridad.</p>
                    <ul class="custom-list">
                        <li><strong>Imparcialidad Total </strong> – No tomamos partido en disputas, solo protegemos la
                            información.</li>
                        <li><strong>Integridad Garantizada</strong> – Los datos no pueden ser alterados ni eliminados
                            sin autorización.</li>
                        <li><strong>Accesos Controlados</strong> – Cada parte obtiene acceso según niveles predefinidos.
                        </li>
                        <li><strong>Disponibilidad Permanente</strong> – Los datos están accesibles en cualquier
                            momento.</li>
                        <li><strong>Cumplimiento Normativo</strong> – Adaptado a GDPR, ISO 27001, HIPAA, SOC 2.</li>
                        <li><strong>Interoperabilidad con Sistemas Existentes</strong> – Compatible con bases de datos,
                            APIs y software empresarial.</li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="customer-support-area pt-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">


                <div class="customer-title">
                    <h2 class="text-center">Seguridad y Cumplimiento Normativo</h2>
                    <p>El servicio de resguardo de datos de enCloud cumple con las normativas más estrictas, asegurando
                        la confidencialidad, integridad y disponibilidad de la información.</p>
                    <ul class="custom-list">
                        <li> <strong>GDPR</strong> (Protección de Datos Europea)</li>
                        <li> <strong>ISO 27001</strong> (Gestión de Seguridad de la Información)</li>
                        <li> <strong>HIPAA</strong> (Protección de Datos de Salud en EE.UU.)</li>
                        <li> <strong>SOC 2</strong> (Controles de Seguridad en la Nube)</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="pricing-area pt-100">
    <div class="container">
        <div class="section-title">
            <h2>📦 Planes de Resguardo de Datos</h2>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete PYMEs</h3>
                        <p>Para pequeñas empresas y startups</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> Capacidad de almacenamiento: (Hasta 100 GB)</li>
                            <li><i class="flaticon-tick"></i> Cifrado de datos: (AES-256 en reposo)</li>
                            <li><i class="flaticon-tick"></i> Control de accesos: (Básico con contraseñas seguras)</li>
                            <li><i class="flaticon-tick"></i> Registros de auditoría (Historial de acceso básico)</li>
                            <li><i class="flaticon-tick"></i> Retención de Datos (Hasta 6 meses)</li>
                            <li><i class="flaticon-tick"></i> Recuperación ante disputas: (Copia Mensual)</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Empresas Medianas </h3>
                        <p>Para negocios en expansión</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> Capacidad de almacenamiento: (Hasta 5 TB)</li>
                            <li><i class="flaticon-tick"></i> Cifrado de datos: (AES-256 + TLS en tránsito)</li>
                            <li><i class="flaticon-tick"></i> Control de accesos: (Roles y permisos avanzados)</li>
                            <li><i class="flaticon-tick"></i> Registros de auditoría (Registro detallado de cada
                                modificación)</li>
                            <li><i class="flaticon-tick"></i> Retención de Datos (Hasta 5 años)</li>
                            <li><i class="flaticon-tick"></i> Recuperación ante disputas: (Backup semanal con
                                recuperación en 12 horas)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing">
                    <div class="pricing-top-heading">
                        <h3>Paquete Personalizado</h3>
                        <p>Para necesidades específicas</p>
                    </div>
                    <div class="custom-price-panel">
                        <span>Características:</span>
                        <ul>
                            <li><i class="flaticon-tick"></i> Capacidad de almacenamiento: (Ilimitado)</li>
                            <li><i class="flaticon-tick"></i> Cifrado de datos: (AES-256 + TLS en tránsito)</li>
                            <li><i class="flaticon-tick"></i> Control de accesos: (Autenticación multifactor y
                                auditorías)</li>
                            <li><i class="flaticon-tick"></i> Registros de auditoría (Reportes automatizados con alertas
                                de actividad sospechosa)</li>
                            <li><i class="flaticon-tick"></i> Retención de Datos (Período configurable según normativas)
                            </li>
                            <li><i class="flaticon-tick"></i> Recuperación ante disputas: (Recuperación instantánea)
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<app-vs-others></app-vs-others>

<app-contact-form [section]="section" [pt]="pt" [pb]="pb" [title]="title"></app-contact-form>

<app-clients [pt]="pt" [pb]="pb"></app-clients>